import { Box, Button } from '@mui/material';
import { useIntl } from 'react-intl';

export function SelectAllOrNoneMui({
  onSelectAll,
  onSelectNone,
  children,
}: {
  readonly onSelectAll?: () => void;
  readonly onSelectNone?: () => void;
  readonly children: React.ReactNode;
}) {
  const { formatMessage } = useIntl();

  return (
    <Box>
      {children}
      {(onSelectAll || onSelectNone) && (
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            mt: 1,
            justifyContent: 'flex-start',
          }}
        >
          {onSelectAll && (
            <Button
              size="small"
              variant="text"
              onClick={onSelectAll}
              sx={{ minWidth: 'auto', p: 0.5 }}
            >
              {formatMessage({
                id: 'common.actions.selectAll',
                defaultMessage: 'Seleccionar todo',
              })}
            </Button>
          )}
          {onSelectNone && (
            <Button
              size="small"
              variant="text"
              onClick={onSelectNone}
              sx={{ minWidth: 'auto', p: 0.5 }}
            >
              {formatMessage({
                id: 'common.actions.selectNone',
                defaultMessage: 'Deseleccionar todo',
              })}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
}
